import { useState, useEffect } from 'react';
import { User } from '../../types/auth';
import { updateUser } from '../../services/userApi';
import axios from 'axios';

interface ProfileForm {
  id: number;
  name: string;
  surname: string;
  phone_number: string;
  identification_number: string;
  management: string;
  office: string;
  authorization_level: 'Admin' | 'User';
}

export const useUserProfile = (userInfo: User | null, isProfileModalOpen: boolean) => {
  const [profileForm, setProfileForm] = useState<ProfileForm>({
    id: userInfo?.id || 0,
    name: userInfo?.name || '',
    surname: userInfo?.surname || '',
    phone_number: userInfo?.phone_number || '',
    identification_number: userInfo?.identification_number || '',
    management: userInfo?.management || '',
    office: userInfo?.office || '',
    authorization_level: (userInfo?.authorization_level as 'Admin' | 'User') || 'User',
  });

  useEffect(() => {
    if (userInfo) {
      setProfileForm({
        id: userInfo.id || 0,
        name: userInfo.name || '',
        surname: userInfo.surname || '',
        phone_number: userInfo.phone_number || '',
        identification_number: userInfo.identification_number || '',
        management: userInfo.management || '',
        office: userInfo.office || '',
        authorization_level: (userInfo.authorization_level as 'Admin' | 'User') || 'User',
      });
    }
  }, [isProfileModalOpen, userInfo]);

  const handleProfileSave = async (
    setUserInfo: React.Dispatch<React.SetStateAction<User | null>>,
    setProfileModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    try {
      // Eğer ID yoksa, telefon numarasına göre kullanıcıyı bul
      let userId: number = profileForm.id;
      if (!userId && userInfo?.phone_number) {
        const findResponse = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/find-by-phone`, {
          phone_number: userInfo.phone_number,
        });
        userId = Number(findResponse.data.id);
      }

      if (!userId) {
        console.error('Kullanıcı ID bulunamadı');
        return;
      }

      const updated = await updateUser({ ...profileForm, id: userId });

      // ProfileForm'u da güncelle ki bir sonraki sefer ID'yi bilsin
      setProfileForm(prev => ({ ...prev, id: userId }));

      setUserInfo(prev => (prev ? { ...prev, ...updated } : prev));
      localStorage.setItem('userInfo', JSON.stringify({ ...userInfo, ...updated }));
      setProfileModalOpen(false);
    } catch (error) {
      console.error('Profil güncelleme hatası:', error);
    }
  };

  return {
    profileForm,
    setProfileForm,
    handleProfileSave,
  };
};
